import { Col, Row } from "react-bootstrap";
import { MdError } from "react-icons/md";


const ErrorMask = ({error}) => {

    return (
        <div className="text-center">
            <Row>
                <Col xl="12">
                    <div className="animate__animated animate__backInRight">
                        <MdError size={80} className="text-danger animate__animated animate__tada animate__delay-2s" />
                    </div>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col>
                    <h3 className="text-danger">Fehler!</h3>
                    <p className="text-muted mt-3">
                        {error && error !== ""? error : "Unbekannter Fehler."}
                    </p>
                </Col>
            </Row>
        </div >
    )
}
export default ErrorMask;